import { useEffect, useState } from 'react';
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import { api, API_URL, authHeaders, clearWebAuthToken } from './api.js';
import Shell from './components/Shell.jsx';
import Admin from './pages/Admin.jsx';
import CivilianHub from './pages/CivilianHub.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Lookup from './pages/Lookup.jsx';
import Linking from './pages/Linking.jsx';
import LiveMap from './pages/LiveMap.jsx';
import Market from './pages/Market.jsx';
import Personas from './pages/Personas.jsx';
import Reports from './pages/Reports.jsx';
import VisualEffects from './components/VisualEffects.jsx';
import { BRAND, logoUrl } from './brand.js';

function Login() {
  return <main className="login-shell">
    <section className="login-card">
      <img className="login-logo" src={logoUrl()} alt={`${BRAND.network} logo`}/>
      <p className="eyebrow">{BRAND.network.toUpperCase()} · {BRAND.city.toUpperCase()}</p>
      <h1>One city.<br/><em>One command.</em></h1>
      <p className="muted">Secure dispatch, records, resident services, banking, and in-game identity for {BRAND.city}.</p>
      {API_URL ? <a className="button primary wide" href={`${API_URL}/auth/discord`}>Continue with Discord</a> : <p className="notice" role="status">The original civilian portal has been recovered. Its banking and account services are awaiting the server connection.</p>}
      {import.meta.env.DEV && <a className="button ghost wide" href={`${API_URL}/auth/dev`}>Developer demo login</a>}
      <p className="fine-print">Authorized {BRAND.city} personnel and residents only.</p>
    </section>
  </main>;
}

export default function App() {
  const [state, setState] = useState({ loading: true, user: null });
  useEffect(() => { api('/me').then(({ user }) => setState({ loading: false, user })).catch(() => setState({ loading: false, user: null })); }, []);
  if (state.loading) return <><VisualEffects/><div className="boot"><div className="brand-mark">GW</div><span>Connecting to Glenwood Metro…</span></div></>;
  if (!state.user) return <><VisualEffects/><Login /></>;
  const cadUser = ['LEO','EMS','DISPATCH','ADMIN'].includes(state.user.role);
  const linkRequired = state.user.role !== 'ADMIN' && !state.user.reforger_uid;
  return <><VisualEffects/><HashRouter><Routes>
    <Route element={<Shell user={state.user} onLogout={() => fetch(`${API_URL}/auth/logout`, {
      method: 'POST', credentials: 'include', headers: authHeaders()
    }).finally(() => { clearWebAuthToken(); location.reload(); })} />}>
      <Route index element={linkRequired ? <Navigate to="/linking" replace /> : cadUser ? <Dashboard /> : <CivilianHub />} />
      <Route path="civilian" element={linkRequired ? <Navigate to="/linking" replace /> : <CivilianHub />} />
      <Route path="lookup" element={linkRequired ? <Navigate to="/linking" replace /> : <Lookup />} />
      <Route path="map" element={linkRequired ? <Navigate to="/linking" replace /> : <LiveMap />} />
      <Route path="linking" element={<Linking user={state.user} />} />
      <Route path="personas" element={linkRequired ? <Navigate to="/linking" replace /> : <Personas />} />
      <Route path="market" element={linkRequired ? <Navigate to="/linking" replace /> : <Market />} />
      <Route path="admin" element={state.user.role === 'ADMIN' ? <Admin user={state.user}/> : <Navigate to="/" replace />} />
      <Route path="reports" element={linkRequired ? <Navigate to="/linking" replace /> : cadUser ? <Reports /> : <Navigate to="/personas" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Route>
  </Routes></HashRouter></>;
}
